"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryProviderEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const InventoryProviderDto_1 = require("./InventoryProviderDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const INDEX_NOT_FOUND = -1;
class InventoryProviderEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, inventoryProvider) {
        super();
        this._requiredFieldsSetStatus = {
            name: false,
            dataSource: false,
            localPath: false,
            ftpUser: false,
            ftpPass: false,
            ftpServer: false,
            enabled: false,
            remotePath: false,
            hostImages: false,
            inventoryIdFromFilename: false,
            excludedFiles: false,
            imageHandler: false
        };
        this._dependencies = dependencies;
        if (inventoryProvider === undefined) {
            this._dto = new InventoryProviderDto_1.InventoryProviderDto();
        }
        else if (inventoryProvider instanceof InventoryProviderDto_1.InventoryProviderDto) {
            this._dto = new InventoryProviderDto_1.InventoryProviderDto(inventoryProvider);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (inventoryProvider instanceof InventoryProviderEntity) {
            this._dto = new InventoryProviderDto_1.InventoryProviderDto(inventoryProvider._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new InventoryProviderDto_1.InventoryProviderDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getDataSource() {
        return this._dto.dataSource;
    }
    setDataSource(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("dataSource");
        this._requiredFieldsSetStatus.dataSource = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("dataSource", "Data Source is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("dataSource", `Data Source has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.dataSource) {
            return;
        }
        this._dto.dataSource = _untrustedValue;
        this._setIsDirty(true);
    }
    getLocalPath() {
        return this._dto.localPath;
    }
    setLocalPath(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("localPath");
        this._requiredFieldsSetStatus.localPath = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("localPath", "Local Path is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("localPath", `Local Path has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.localPath) {
            return;
        }
        this._dto.localPath = _untrustedValue;
        this._setIsDirty(true);
    }
    getFtpUser() {
        return this._dto.ftpUser;
    }
    setFtpUser(untrustedValue) {
        const minLength = 3;
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("ftpUser");
        this._requiredFieldsSetStatus.ftpUser = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("ftpUser", "Ftp User is required."));
        }
        else if (_untrustedValue.length < minLength) {
            this.addError(new ValidationError_1.ValidationError("ftpUser", `Ftp User is below the minimum length (${minLength} chr).`));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("ftpUser", `Ftp User has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.ftpUser) {
            return;
        }
        this._dto.ftpUser = _untrustedValue;
        this._setIsDirty(true);
    }
    getFtpPass() {
        return this._dto.ftpPass;
    }
    setFtpPass(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("ftpPass");
        this._requiredFieldsSetStatus.ftpPass = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("ftpPass", "Ftp Pass is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("ftpPass", `Ftp Pass has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.ftpPass) {
            return;
        }
        this._dto.ftpPass = _untrustedValue;
        this._setIsDirty(true);
    }
    getFtpServer() {
        return this._dto.ftpServer;
    }
    setFtpServer(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("ftpServer");
        this._requiredFieldsSetStatus.ftpServer = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("ftpServer", "Ftp Server is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("ftpServer", `Ftp Server has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.ftpServer) {
            return;
        }
        this._dto.ftpServer = _untrustedValue;
        this._setIsDirty(true);
    }
    getEnabled() {
        return this._dto.enabled;
    }
    setEnabled(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("enabled", "Enabled is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("enabled", "Enabled is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.enabled) {
            return;
        }
        this.clearError("enabled");
        this._requiredFieldsSetStatus.enabled = true;
        this._dto.enabled = _untrustedValue;
        this._setIsDirty(true);
    }
    getRemotePath() {
        return this._dto.remotePath;
    }
    setRemotePath(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("remotePath");
        this._requiredFieldsSetStatus.remotePath = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("remotePath", "Remote Path is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("remotePath", `Remote Path has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.remotePath) {
            return;
        }
        this._dto.remotePath = _untrustedValue;
        this._setIsDirty(true);
    }
    getHostImages() {
        return this._dto.hostImages;
    }
    setHostImages(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("hostImages", "Host Images is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("hostImages", "Host Images is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.hostImages) {
            return;
        }
        this.clearError("hostImages");
        this._requiredFieldsSetStatus.hostImages = true;
        this._dto.hostImages = _untrustedValue;
        this._setIsDirty(true);
    }
    getInventoryIdFromFilename() {
        return this._dto.inventoryIdFromFilename;
    }
    setInventoryIdFromFilename(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("inventoryIdFromFilename", "Inventory Id From Filename is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("inventoryIdFromFilename", "InventoryIdFromFilename is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.inventoryIdFromFilename) {
            return;
        }
        this.clearError("inventoryIdFromFilename");
        this._requiredFieldsSetStatus.inventoryIdFromFilename = true;
        this._dto.inventoryIdFromFilename = _untrustedValue;
        this._setIsDirty(true);
    }
    getExcludedFiles() {
        return this._dto.excludedFiles;
    }
    setExcludedFiles(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("excludedFiles");
        this._requiredFieldsSetStatus.excludedFiles = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("excludedFiles", "Excluded Files is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("excludedFiles", `Excluded Files has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.excludedFiles) {
            return;
        }
        this._dto.excludedFiles = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageHandler() {
        return this._dto.imageHandler;
    }
    setImageHandler(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("imageHandler");
        this._requiredFieldsSetStatus.imageHandler = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("imageHandler", "Image Handler is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("imageHandler", `Image Handler has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.imageHandler) {
            return;
        }
        this._dto.imageHandler = _untrustedValue;
        this._setIsDirty(true);
    }
    getLastProcessingActivityOn() {
        return this._dto.lastProcessingActivityOn;
    }
    getLastProcessingSessionStarted() {
        return this._dto.lastProcessingSessionStarted;
    }
    getLastProcessingSessionEnded() {
        return this._dto.lastProcessingSessionEnded;
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.inventoryProviderDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Inventory Provider is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.inventoryProviderDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.inventoryProviderDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Inventory Provider cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.inventoryProviderDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.InventoryProviderEntity = InventoryProviderEntity;
//# sourceMappingURL=InventoryProviderEntity.js.map